import { StyleSheet, View } from 'react-native';
import React, { useCallback, useEffect, useState } from 'react';
import TableForm from '../TableForm';
import { FormType, UserRole } from '../../../../utils/enums';
import { PrivateStackScreenProps } from '../../../../app/navigation/types';
import useToggle from '../../../../hooks/useToggle';
import { useFirestore } from '../../../../app/providers/firestore';
import { useAppSelector } from '../../../../hooks/hooks';
import { ITable } from '../../../../models/ITable';
import { useFocusEffect } from '@react-navigation/native';
import { IconButton } from 'react-native-paper';
import collections from '../../../../utils/collections';
import Spacing from '../../../../res/constants/Spacing';
import Styles from '../../../../res/constants/Styles';
import useColorScheme from '../../../../hooks/useColorScheme';

const TableDetailScreen = ({ navigation, route }: PrivateStackScreenProps<'TableDetail'>) => {
  // #region MEMBERS
  const key: string | undefined = route.params.key;
  const formType: FormType = route.params.type;
  const archivedMode: boolean = route.params.archivedMode;
  // #endregion
  // #region STATES
  const [currentModel, setCurrentModel] = useState<ITable | undefined>(undefined);
  const [confirmDialogVisibility, toggleConfirmDialog] = useToggle(false);
  const [loading, toggleLoading] = useToggle(false);
  // #endregion
  // #region CUSTOM HOOKS
  const { handleGetDocument, currentUser } = useFirestore();
  const currentSelectedUser = useAppSelector((state) => state.backOffice.selectedUser);
  const colorScheme = useColorScheme();
  const localTheme = Styles[colorScheme];

  // #endregion
  // #region FUNCTIONS
  const handleTargetUid = () => {
    if (currentUser) {
      if (currentUser.role === UserRole.BACKOFFICE) {
        if (currentSelectedUser) return currentSelectedUser.uid;
        else return currentUser.uid;
      } else {
        return currentUser.uid;
      }
    }
  };

  const handleClearObject = () => {
    setCurrentModel(undefined);
    navigation.navigate('EditTable', { key, type: FormType.EDIT });
  };

  // #endregion
  // #region EFFECTS
  useFocusEffect(
    useCallback(() => {
      const uid = handleTargetUid(); // FIXME: Nuk eshte ok, duhet pare
      if (uid === undefined || key === undefined) return;

      toggleLoading(true);

      handleGetDocument(uid, key, collections.table).then((value) => {
        setCurrentModel(value);
        toggleLoading(false);
      });
    }, [currentUser, currentSelectedUser, key])
  );

  useEffect(() => {
    navigation.setOptions({
      headerRight: () =>
        currentModel !== undefined && <IconButton icon={archivedMode ? 'delete-restore' : 'delete'} onPress={() => toggleConfirmDialog()} />,
    });
  }, [currentModel, archivedMode, key]);
  // #endregion
  return (
    <View style={[styles.root, { backgroundColor: localTheme.lightSelectedItem }]}>
      <TableForm {...{ currentModel, formType, archivedMode, confirmDialogVisibility, toggleConfirmDialog }} handleClearObject={handleClearObject} />
    </View>
  );
};

export default TableDetailScreen;

const styles = StyleSheet.create({ root: { flex: 1, padding: Spacing.regular } });
